import { render, staticRenderFns } from "./AppNavbar.vue?vue&type=template&id=b83289fa&scoped=true&"
import script from "./AppNavbar.vue?vue&type=script&lang=ts&"
export * from "./AppNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavbar.vue?vue&type=style&index=0&id=b83289fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83289fa",
  null
  
)

export default component.exports